import dedent from 'ts-dedent';
import { Provider, WorkflowComponentParamType } from '../types';
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent';
class Sample extends SelectSameSchemaWorkflowComponent {
    constructor() {
        super({
            name: 'native.sample',
            group: 'Data Preparation',
            title: 'Sample',
            description: `
      This component generates a new table with a random sample of N rows from an input table.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'nrows',
                type: WorkflowComponentParamType.Number,
                title: 'Number of rows to sample',
                min: 1
            }
        ]);
        // In BQ, the output from this component cannot be optimized
        this.inputs = this.inputs.filter((input) => !input.providers?.includes(Provider.BigQuery) ?? true);
    }
    getInnerSql({ params, connection }) {
        switch (connection.type) {
            case Provider.BigQuery:
                return dedent `SELECT *
              FROM ${connection.quoteName(params.source)}
              ORDER BY RAND()
              LIMIT ${params.nrows}`;
            case Provider.DatabricksRest:
                return dedent `SELECT /*+ REPARTITION(40) */
                *
              FROM ${connection.quoteName(params.source)}
              ORDER BY RANDOM()
              LIMIT ${params.nrows}`;
            default:
                return dedent `SELECT *
              FROM ${connection.quoteName(params.source)}
              ORDER BY RANDOM()
              LIMIT ${params.nrows}`;
        }
    }
}
export { Sample };
